{
  "label": {
    "addUser": "Benutzer hinzufügen",
    "cancel": "Abbrechen",
    "clearFilter": "Filter zurücksetzen",
    "delete": "Löschen",
    "errorDeleting": "Beim Löschen ist ein Fehler aufgetreten.",
    "errorHeader": "Fehler",
    "invalidData": "Ungültige Daten",
    "manageUserFields": "Benutzerfelder verwalten",
    "onboardingMailError": "Beim Senden der Onboarding-Mail ist ein Fehler aufgetreten.",
    "onboardingMailSent": "Die Onboarding-Mail wurde erfolgreich gesendet.",
    "save": "Speichern",
    "search": "Suchen",
    "sendOnboardingMail": "Onboarding-Mail senden",
    "successfullyDeleted": "Der Eintrag wurde erfolgreich gelöscht.",
    "successfullyDeletedHeader": "Erfolgreich gelöscht",
    "successHeader": "Erfolg"
  },
  "message": {
    "noUserData": "Keine Benutzerdaten vorhanden."
  },
  "user": {
    "create": "Benutzer erstellen",
    "createFailed": "Benutzer konnte nicht erstellt werden.",
    "created": "Benutzer erfolgreich erstellt.",
    "deleteConfirmMessage": "Möchten Sie diesen Benutzer wirklich löschen?",
    "deleteHeader": "Benutzer löschen",
    "edit": "Benutzer bearbeiten",
    "updateFailed": "Benutzer konnte nicht aktualisiert werden.",
    "updated": "Benutzer erfolgreich aktualisiert."
  }
}